// eslint-disable-next-line import/no-unresolved
import { documentToPlainTextString } from "@contentful/rich-text-plain-text-renderer";

const getFaqData = categories => {
	const resultArr = [];
	categories?.forEach(cat =>
		cat?.subCategories?.forEach(subCat =>
			subCat?.faqItems?.forEach(i =>
				resultArr.push({
					subCategory: subCat?.displayTitle,
					question: i?.question,
					content: i?.answer,
					contentString: documentToPlainTextString(JSON.parse(i?.answer?.raw)),
					ctf_id: i?.contentful_id,
					slug: i?.slug,
					order: i?.searchPriorityOrder || 0,
				})
			)
		)
	);
	return resultArr;
};

export default getFaqData;
export { getFaqData };
